import { Document, Page, Text, View } from '@react-pdf/renderer'

import { BarChartSection } from '@/components/StatsExport/components/BarChartSection/BarChartSection'
import { ListSection } from '@/components/StatsExport/components/ListSection/ListSection'
import { Logo } from '@/components/StatsExport/components/Logo/Logo'
import { UsersSection } from '@/components/StatsExport/components/UserSection/UsersSection'
import { styles } from '@/components/StatsExport/StatsExport.config'
import type { StatsExportProps } from '@/components/StatsExport/StatsExport.types'

export function StatsExport({ chartsData, companyName }: StatsExportProps) {
  const { age, gender, income, race, topics, users } = chartsData

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.logo}>
          <Logo />
        </View>

        {companyName && (
          <View>
            <Text style={styles.text}>{companyName}</Text>
          </View>
        )}

        <View style={styles.container}>
          <UsersSection data={users} title="Users" />

          <BarChartSection data={age} title="Age" />

          <BarChartSection data={income} title="Income" />

          <ListSection data={gender} title="Gender" />

          <ListSection data={race} title="Race" />

          <ListSection data={topics} title="Topics" />
        </View>
      </Page>
    </Document>
  )
}
